import { useContext, useEffect, useState } from "react";
import { NavBar } from "../../utils/types";
import { Header } from "../../components/Header";
import { FormModal } from "../../components/Forms/LoginModal";
import { UserInfoForm } from "../../components/Forms/UserInfoForm";
import { UserContext } from "../../context/user-context/userContext";
import { Helmet } from "react-helmet";
import { colors } from "../../utils/colors";
import { UserFeedBack } from "../../components/Forms/user-feedback/UserFeedBack";

// export const json = {
//     name: "nps survey",
//     completedHtmlOnCondition: [
//         {
//             expression: "{nps-score} <= 6 or {rebuy} = false",
//             html: {
//                 default:
//                     "Thanks for your feedback! We highly value all ideas and suggestions from our customers, whether they're positive or critical. In the future, our team might reach out to you to learn more about how we can further improve our product so that it exceeds your expectations.",
//                 fr: "Merci pour vos commentaires! Nous accordons une grande importance à toutes les idées et suggestions de nos clients, qu'elles soient positives ou critiques. À l'avenir, notre équipe pourrait vous contacter pour en savoir plus sur la façon dont nous pouvons encore améliorer notre produit afin qu'il dépasse vos attentes."
//             }
//         },
//         {
//             expression: "{nps-score} = 6 or {nps-score} = 7",
//             html: {
//                 default:
//                     "Thanks for your feedback. Our goal is to create the best possible product, and your thoughts, ideas, and suggestions play a major role in helping us identify opportunities to improve.",
//                 fr: "Merci pour vos commentaires. Notre objectif est de créer le meilleur produit possible, et vos réflexions, idées et suggestions jouent un rôle majeur pour nous aider à identifier les opportunités d'amélioration."
//             }
//         },
//         {
//             expression: "{nps-score} >= 8",
//             html: {
//                 default:
//                     "Thanks for your feedback. It's great to hear that you're a fan of our product. Your feedback helps us discover new opportunities to improve it and make sure you have the best possible experience.",
//                 fr: "Merci pour vos commentaires. Nous sommes ravis d'entendre que vous avez apprécié notre produit. Vos commentaires nous aident à découvrir de nouvelles opportunités pour l'améliorer et vous assurer la meilleure expérience possible."
//             }
//         }
//     ],
//     pages: [
//         {
//             name: "page1",
//             elements: [
//                 {
//                     id: "nps-dropdown",
//                     type: "rating",
//                     name: "nps-score",
//                     title: {
//                         default:
//                             "On a scale from 0 to 10, how likely are you to recommend us to a friend or family member?"
//                     },
//                     rateMin: 0,
//                     rateMax: 10,
//                     minRateDescription: {
//                         default: "Very unlikely"
//                     },
//                     maxRateDescription: {
//                         default: "Very likely"
//                     },
//                     rateDescriptionLocation: "bottom"
//                 },
//                 {
//                     type: "comment",
//                     name: "disappointing-experience",
//                     visibleIf: "{nps-score} <= 5",
//                     title: {
//                         default: "How did we disappoint you and what can we do to make things right?"
//                     },
//                     maxLength: 300
//                 },
//                 {
//                     type: "comment",
//                     name: "improvements-required",
//                     visibleIf: "{nps-score} >= 6",
//                     title: {
//                         default: "What can we do to make your experience more satisfying?"
//                     },
//                     maxLength: 300
//                 },
//                 {
//                     type: "checkbox",
//                     name: "promoter-features",
//                     visibleIf: "{nps-score} >= 9",
//                     title: {
//                         default: "Which of the following features do you value the most in a vehicle?"
//                     },
//                     description: {
//                         default: "Please select no more than three features."
//                     },
//                     isRequired: true,
//                     choices: [
//                         {
//                             value: "mpg",
//                             text: "Miles Per Gallon"
//                         },
//                         {
//                             value: "space",
//                             text: {
//                                 default: "Space"
//                             }
//                         },
//                         {
//                             value: "body",
//                             text: {
//                                 default: "Body Type"
//                             }
//                         },
//                         {
//                             value: "luxury features",
//                             text: {
//                                 default: "Luxury Features"
//                             }
//                         },
//                         {
//                             value: "brand",
//                             text: {
//                                 default: "brand"
//                             }
//                         }
//                     ],
//                     showOtherItem: true,
//                     otherPlaceholder: {
//                         default: "Please specify..."
//                     },
//                     otherText: {
//                         default: "Other features"
//                     },
//                     colCount: 2,
//                     maxSelectedChoices: 3
//                 }
//             ]
//         },
//         {
//             name: "page2",
//             elements: [
//                 {
//                     type: "boolean",
//                     name: "rebuy",
//                     title: {
//                         default: "Would you rent from Cargo again?"
//                     }
//                 }
//             ]
//         },
//         {
//             name: "page3",
//             elements: [
//                 {
//                     type: "radiogroup",
//                     name: "testimonial",
//                     title: {
//                         default: "Would you mind providing us a brief testimonial for the website?"
//                     },
//                     choices: [
//                         {
//                             value: "yes",
//                             text: {
//                                 default: "Sure!"
//                             }
//                         },
//                         {
//                             value: "no",
//                             text: {
//                                 default: "No"
//                             }
//                         }
//                     ]
//                 },
//                 {
//                     type: "text",
//                     name: "email",
//                     visibleIf: "{testimonial} = 'yes'",
//                     title: {
//                         default: "What is your email address?"
//                     },
//                     validators: [
//                         {
//                             type: "email"
//                         }
//                     ],
//                     placeholder: {
//                         default: "Enter your email here"
//                     }
//                 }
//             ]
//         }
//     ],
//     showPrevButton: false,
//     showQuestionNumbers: "off",
//     completeText: {
//         fr: "Envoyer"
//     },
//     widthMode: "static",
//     width: "auto"
// };

export const HomePage = () => {
    const performance = window.performance;
    const start = performance.mark("home-load-start");

    const structuredData = {
        "@context": "https://schema.org",
        "@type": "FinancialService",
        name: "Wells Cargo",
        knowsAbout: ["Consumer Banking"],
        currenciesAccepted: "USD",
        openingHours: "Mo, Tu, We, Th, Fr, 9:00 - 17:00",
        address: {
            "@type": "PostalAddress",
            streetAddress: "123 Sesame St",
            addressLocality: "New York City",
            addressRegion: "NY",
            postalCode: "10001",
            addressCountry: "USA"
        }
    };

    // CONTEXT
    const userContext = useContext(UserContext);
    const { navToAccount } = userContext;

    // STATES
    const [navBarContents, setNavBarContents] = useState<NavBar[]>([
        {
            title: "Personal",
            link: "",
            selected: true
        },
        {
            title: "Wealth Management",
            link: "",
            selected: false
        },
        {
            title: "Small Business",
            link: "",
            selected: false
        },
        {
            title: "Commercial Investing",
            link: "",
            selected: false
        }
    ]);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [showPromo, setShowPromo] = useState<boolean>(false);
    const [showHeader, setShowHeader] = useState<boolean>(false);
    // FUNCTIONS
    const setSelected = (index: number) => {
        const allItems = [
            {
                title: "Personal",
                link: "",
                selected: false
            },
            {
                title: "Wealth Management",
                link: "",
                selected: false
            },
            {
                title: "Small Business",
                link: "",
                selected: false
            },
            {
                title: "Commercial Investing",
                link: "",
                selected: false
            }
        ];

        allItems[index].selected = true;
        setNavBarContents(allItems);
    };

    // useEffect
    useEffect(() => {
        const promo = window.localStorage.getItem("promo_bool");
        if (promo) {
            setShowPromo(true);
        }
    }, []);

    useEffect(() => {
        setTimeout(() => {
            setShowHeader(true);
        }, 3000);
    }, []);

    const end = performance.mark("home-load-finish");

    const loadMeasure = end.startTime - start.startTime;
    console.log("home Measure", loadMeasure);
    return (
        <div style={{ height: "100vh", display: "flex", flexDirection: "column" }}>
            <Helmet>
                <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
            </Helmet>
            {showHeader && <Header />}
            <div className="home-nav-bar">
                <div className="home-nav-bar-content">
                    {navBarContents.map((x, i) => {
                        return (
                            <button
                                onClick={() => setSelected(i)}
                                className={`home-nav-button ${x.selected ? "home-nav-button_selected" : ""}`}
                                key={`nav-${i}`}
                            >
                                {x.title}
                            </button>
                        );
                    })}
                </div>
            </div>
            <div className="home-page-content-container">
                <div className="home-page-content">
                    <div className="login-container">
                        <div className="login-contents">
                            <h2 style={{ padding: "20px", fontSize: "40px" }}>Welcome Back</h2>

                            <UserInfoForm changeForm={true} formType="login" submitCallback={() => navToAccount()} />
                        </div>
                    </div>

                    {!showPromo && (
                        <div className="sign-up-container">
                            <div className="home-text-container">
                                <h1>Simplify Your Banking</h1>
                                <p style={{ fontSize: "28px" }}>
                                    Your money at your fingertips with <b>Easy Checking</b>
                                </p>
                            </div>
                            <div className="home-button-container">
                                <button className="big-green-button" onClick={() => setShowModal(true)}>
                                    Start Now
                                </button>
                            </div>
                        </div>
                    )}

                    {showPromo && (
                        <div
                            style={{
                                padding: "30px",
                                height: "50%",
                                flex: "0.65",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-around"
                            }}
                        >
                            <h4 style={{ fontSize: "30px" }}>New Checking Customers!</h4>

                            <div>
                                <p style={{ fontSize: "100px", color: colors.darkGreen }}>$300</p>
                            </div>

                            <p style={{ fontSize: "25px" }}>
                                Earn a <b>$300</b> cash offer when you open a new eligable checking account
                            </p>
                            <p style={{ fontSize: "25px" }}>and make qualifying direct deposits.</p>

                            <div>
                                <button
                                    style={{
                                        width: "150px",
                                        padding: "10px 0",
                                        backgroundColor: "white",
                                        cursor: "pointer",
                                        border: "1px solid black",
                                        borderRadius: "20px",
                                        fontSize: "15px"
                                    }}
                                >
                                    Learn More
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <UserFeedBack />
            <FormModal
                title={"Enroll"}
                show={showModal}
                close={() => setShowModal(false)}
                Form={<UserInfoForm formType="enroll" submitCallback={() => navToAccount()} />}
            />
        </div>
    );
};
